import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";

const ModalDeuda = ({ data,deudaOpen, title, opacity, children, width = 'sm:w-full sm:max-w-sm', bgColor = 'bg-primarioMira',  paddingTop = 'sm:my-8 sm:p-6 pt-5' }) => {

  function validar(numeroParam){
    return numeroParam.toString().split('.').length === 2 ? numeroParam : numeroParam + ".00"
  }

  return (
    <>

   
              {deudaOpen ? (
                <>
                <Transition.Root show={deudaOpen} as={Fragment} className="block overflow-scroll">
                  <Dialog
                    as="div"
                    className="relative z-10 "
                    onClose={() => !deudaOpen}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div
                        className={
                          `fixed inset-0 bg-secundarioMira ` +
                          opacity +
                          ` transition-opacity`
                        }
                      />
                    </Transition.Child>

                    <div className="fixed inset-0 z-30 overflow-y-auto">
                      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                          enterTo="opacity-100 translate-y-0 sm:scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                          <div
                            className={`z-30 relative transform overflow-hidden rounded-lg ${bgColor} px-4 ${paddingTop} pb-4 text-left shadow-xl transition-all ${width}`}
                          >
                            <div>
                              <div className="w-full">
                                <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
                              </div>
                              <div className="mt-3 text-center sm:mt-5">
                                <Dialog.Title
                                  as="h3"
                                  className="text-xl font-medium leading-6 text-white"
                                >
                                  {title}
                                </Dialog.Title>
                                <div className="mt-2">
                                  <div>
                                    <div className="text-center">
                                      <Dialog.Title
                                        as="h3"
                                        className="text-xl font-medium leading-6 text-white m-2"
                                      >
                                        {"Estado de Cuenta"}
                                      </Dialog.Title>
                                    </div>
                                    <p
                                      id="alertapago"
                                      className="text-justify text-white"
                                    >
                                      Queremos recordarle que usted posee un
                                      descuento al día de hoy en sus
                                      colegiaturas de{" "}
                                      <b className="text-secundario ">
                                        Q.{validar(data.Descuento)}
                                      </b>{" "}
                                      y que, la cuota autorizada por el{" "}
                                      <strong>Ministerio de Educación</strong>{" "}
                                      es de
                                      <b className="text-danger text-secundario">
                                        {" "}
                                        Q.{validar(data.Autorizado)}{" "}
                                      </b>
                                      y de no cancelar en la fecha estipulada,
                                      cada día varía la cuota de descuento. Por
                                      lo tanto, es indispensable mantener sus
                                      cuotas al día para seguir gozando del
                                      beneficio suscrito en el convenio. Su
                                      apoyo en el pago de la colegiatura es
                                      vital para seguir operando de la mejor
                                      manera. SI VE ESTE MENSAJE AÚN ESTA
                                      PENDIENTE DE PAGO{" "}
                                      <b className="text-secundario">
                                        <span id="textdias">
                                          {" "}
                                          Y TIENE {data.diasv2} DÍAS DE ATRASO.
                                        </span>
                                      </b>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {children}
                          </div>
                        </Transition.Child>
                      </div>
                    </div>
                    
                  </Dialog>
                </Transition.Root>
                </>
              ) : null}
      

    </>
  );
};

export default ModalDeuda;
